<div class="d-flex"
*ngIf="crossReference.crossReferenceType !== 'NO_MATCH' && !(!hasPermissionToAddOpinions && opinion === 'NO_OPINION')">
  <app-assessment-notes
      defaultDropdown="Vizient Assessment"
      [canAddNotes]="true"
      [canUpdateOpinion]="hasPermissionToAddOpinions"
      [isOpinionDropdownVisible]="!isGPO"
      (createNote)="onAddNote($event)"
      (updateOpinion)="onUpdateOpinion($event)"
      [notes]="crossReference.gpoNotes"
  />
  <app-vizient-assessment-vote 
      [opinion]="opinion"
      [hasPermissionToAddOpinions]="hasPermissionToAddOpinions"
      (updateOpinion)="onUpdateOpinion($event)"/>
</div>
